module.exports = __webpack_public_path__ + "img/sort-ascending.5cadc257.svg";